module.exports = __webpack_public_path__ + "img/125-finland.88a671ba.svg";